/* Arnold & Co custom: play product tile hover videos on hover */
(function () {
  function tileVideos(tile) {
    return tile.querySelectorAll('.grid-product__video-hover video');
  }
  document.addEventListener('mouseover', function (e) {
    if (!e.target.closest) return;
    var tile = e.target.closest('.grid-product');
    if (!tile) return;
    tileVideos(tile).forEach(function (v) {
      if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    });
  });
  document.addEventListener('mouseout', function (e) {
    if (!e.target.closest) return;
    var tile = e.target.closest('.grid-product');
    if (!tile) return;
    if (e.relatedTarget && tile.contains(e.relatedTarget)) return;
    tileVideos(tile).forEach(function (v) { v.pause(); v.currentTime = 0; });
  });
})();
